// extracted by mini-css-extract-plugin
module.exports = {"main":"templateStyles_main__ie4hp","noMainMargin":"templateStyles_noMainMargin__s2agc"};